import styled from 'styled-components'

export const Wrapper = styled.div`
  text-align: center;
  margin-top: 24px;
  img {
    max-height: 475px;
    border-radius: 8px;
  }
  video {
    width: 100%;
    max-height: 475px;
    background: black;
    border-radius: 8px;
  }
  iframe {
    width: 100%;
    height: 475px;
    border-radius: 8px;
  }
  div {
    word-break: break-word;
  }
`
